var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-assistant-container"},[(_vm.iframeUrl)?_c('iframe',{staticClass:"ai-assistant-iframe",attrs:{"src":_vm.iframeUrl}}):_c('div',{staticClass:"ai-assistant-loading"},[_vm._v(" Загрузка... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }